module.exports = __webpack_public_path__ + "static/media/noun_desktop_1565605.c3a65145.svg";